/**
 * Get elements from a slot
 * @param shadowRoot - The shadow root of the component
 * @param slotId - The id of the slot
 * @returns The elements in the slot
 */
export function getElementsFromSlot<T>(shadowRoot: ShadowRoot | null, slotId: string, tagSelectors?: string[]): T[] {
  if (shadowRoot == null) {
    return [];
  }

  const slot = shadowRoot.querySelector(`#${slotId}`);
  if (slot) {
    let elements = (slot as HTMLSlotElement).assignedElements();

    if (tagSelectors && tagSelectors.length > 0) {
      elements = elements.filter(element => {
        return tagSelectors.some(selector => {
          // Handle wildcard selectors
          if (selector.endsWith("*")) {
            const prefix = selector.slice(0, -1);
            return element.tagName.toLowerCase().startsWith(prefix.toLowerCase());
          }
          // Handle exact matches
          return element.tagName.toLowerCase() === selector.toLowerCase();
        });
      });
    }

    return elements as T[];
  }

  return [];
}
/**
 * Get nodes from a slot
 * @param shadowRoot - The shadow root of the component
 * @param slotId - The id of the slot
 * @returns The nodes in the slot
 */
export function getNodesFromSlot<T>(shadowRoot: ShadowRoot | null, slotId: string): T[] {
  if (shadowRoot == null) {
    return [];
  }

  const slot = shadowRoot.querySelector(`#${slotId}`);
  if (slot) {
    const elements = (slot as HTMLSlotElement).assignedNodes();
    return elements as T[];
  }

  return [];
}
